import React__default, { useRef, useState, useEffect } from 'react';
import classNames from 'classnames';
import Styles from './ScrollableContainer.module.scss.js';
import { useIntersect } from '../../hooks/useIntersect.js';
import { ReactComponent as SvgNfAngleRightWhite } from '../../icons/nf_angleRightWhite.svg.js';

const ScrollableContainer = ({ children, containerClass, rowClass, nextArrowClass, prvArrowClass, nextNavShadowClass, prvNavShadowClass, scrollBy, isShow, items, fallback, length, autoScroll, fetchMoreItems, hasMoreItems, isNavShadow = true, showNavArrows = true, itemWrapperClass }) => {
    /***
     * Refs
     */
    const elmRef = useRef(null);
    const tempRef = useRef(null);
    /***
     * States
     */
    const [prvShow, setPrvShow] = useState(false);
    const [nextShow, setNextShow] = useState(false);
    const [scrollByitemWidth, setScrollByitemWidth] = useState(0);
    /***
     * Hooks
     */
    const { entry: rowSectionObj, setNode: rowRef } = useIntersect({
        threshold: 1
    });
    const { entry: firstInterSectionObj, setNode: firstElmRef } = useIntersect({
        threshold: 0.9
    });
    const { entry: lastInterSectionObj, setNode: lastElmRef } = useIntersect({
        threshold: 0.9
    });
    /***
     * Effects
     */
    useEffect(() => {
        if (scrollByitemWidth) {
            scrollHorizontal(scrollByitemWidth);
        }
    }, [scrollByitemWidth]);
    useEffect(() => {
        if ((lastInterSectionObj === null || lastInterSectionObj === void 0 ? void 0 : lastInterSectionObj.intersectionRatio) < 0.9 &&
            (rowSectionObj === null || rowSectionObj === void 0 ? void 0 : rowSectionObj.intersectionRatio) === 1) {
            setNextShow(true);
        }
        else {
            setNextShow(false);
            if (hasMoreItems) {
                fetchMoreItems === null || fetchMoreItems === void 0 ? void 0 : fetchMoreItems();
            }
        }
        return () => {
            setNextShow(false);
        };
    }, [lastInterSectionObj, length, rowSectionObj]);
    useEffect(() => {
        if ((firstInterSectionObj === null || firstInterSectionObj === void 0 ? void 0 : firstInterSectionObj.intersectionRatio) < 0.9 &&
            (rowSectionObj === null || rowSectionObj === void 0 ? void 0 : rowSectionObj.intersectionRatio) === 1) {
            setPrvShow(true);
        }
        else {
            if ((items === null || items === void 0 ? void 0 : items.length) === 1) {
                setNextShow(false);
            }
            setPrvShow(false);
        }
        return () => {
            setPrvShow(false);
        };
    }, [firstInterSectionObj, length, rowSectionObj]);
    /**
     * Handler Functions
     */
    const handlePrvArrow = () => {
        setScrollByitemWidth(tempRef.current.offsetWidth * scrollBy * -1);
    };
    const handleNextArrow = () => {
        setScrollByitemWidth(tempRef.current.offsetWidth * scrollBy);
    };
    const scrollHorizontal = (scrollOffset) => {
        elmRef.current.scrollLeft += scrollOffset;
        setScrollByitemWidth(0);
    };
    //AutoScroll
    useEffect(() => {
        if (autoScroll === "SCROLL_LR") {
            setScrollByitemWidth(tempRef.current.offsetWidth * length);
        }
    }, []);
    useEffect(() => {
        if ((rowSectionObj === null || rowSectionObj === void 0 ? void 0 : rowSectionObj.intersectionRatio) === 1 &&
            (autoScroll === "SCROLL_RL" || autoScroll === "SCROLL_LR")) {
            const interval = setInterval(() => {
                if (autoScroll === "SCROLL_RL") {
                    if ((lastInterSectionObj === null || lastInterSectionObj === void 0 ? void 0 : lastInterSectionObj.intersectionRatio) < 0.9) {
                        setScrollByitemWidth(tempRef.current.offsetWidth * scrollBy);
                    }
                    else {
                        setScrollByitemWidth(tempRef.current.offsetWidth * length * -1);
                    }
                }
                else if (autoScroll === "SCROLL_LR") {
                    if ((firstInterSectionObj === null || firstInterSectionObj === void 0 ? void 0 : firstInterSectionObj.intersectionRatio) < 0.9) {
                        setScrollByitemWidth(tempRef.current.offsetWidth * scrollBy * -1);
                    }
                    else {
                        setScrollByitemWidth(tempRef.current.offsetWidth * length);
                    }
                }
            }, 3000);
            return () => {
                clearInterval(interval);
            };
        }
    }, [rowSectionObj, firstInterSectionObj, lastInterSectionObj, scrollByitemWidth]);
    return (React__default.createElement("div", { className: classNames(Styles.main, containerClass, prvShow ? isShow : "") },
        ((items === null || items === void 0 ? void 0 : items.length) || children) && (React__default.createElement(React__default.Fragment, null,
            React__default.createElement("div", { ref: rowRef },
                React__default.createElement("div", { ref: elmRef, className: classNames(Styles.row, rowClass) }, items === null || items === void 0 ? void 0 :
                    items.map((item, index) => (React__default.createElement("div", { className: classNames(itemWrapperClass), ref: index === 0 ? firstElmRef : index === items.length - 1 ? lastElmRef : tempRef, key: index }, item))),
                    children)),
            showNavArrows && prvShow && (React__default.createElement(React__default.Fragment, null,
                React__default.createElement("span", { className: classNames(Styles.prev, prvArrowClass), onClick: handlePrvArrow },
                    React__default.createElement(SvgNfAngleRightWhite, null)),
                isNavShadow && (React__default.createElement("span", { className: classNames(Styles.prvNavShadow, prvNavShadowClass) })))),
            showNavArrows && nextShow && (React__default.createElement(React__default.Fragment, null,
                React__default.createElement("span", { className: classNames(Styles.next, nextArrowClass), onClick: handleNextArrow },
                    React__default.createElement(SvgNfAngleRightWhite, null)),
                isNavShadow && (React__default.createElement("span", { className: classNames(Styles.nextNavShadow, nextNavShadowClass) })))))),
        fallback));
};

export { ScrollableContainer as default };
//# sourceMappingURL=ScrollableContainer.js.map
